import { Button, Modal } from 'antd';
import { useNavigate } from 'react-router-dom-v5-compat';
import { useStoreActions, useStoreState } from '../../../store';
import { useArchiveSimulation } from '~/hooks/simulation/useSimulationSetupMutations';
export interface SimulationCancelButtonProps {
  simulationId?: string | null;
}
export const SimulationCancelButton = ({ simulationId }: SimulationCancelButtonProps) => {
  const archiveSimulation = useArchiveSimulation();
  const sessionPartnerUrl = useStoreState((state) => state.session.user?.sessionPartnerUrl);
  const setActiveNavigationStep = useStoreActions((actions) => actions.simulation.setActiveNavigationStep);
  const [modal, contextHolder] = Modal.useModal();
  const navigate = useNavigate();
  const handleConfirm = () => {
    setActiveNavigationStep(0);
    if (!simulationId) {
      navigate(`/${sessionPartnerUrl}/simulation`);
      return;
    }
    archiveSimulation.mutateAsync({ simulationId }).then(() => {
      navigate(`/${sessionPartnerUrl}/simulation`);
    });
  };
  return (
    <div>
      {contextHolder}
      <Button
        onClick={async () => {
          await modal.confirm({
            title: 'Cancel Simulation Setup',
            content: <p>Are you sure you want to cancel your simulation setup? Progress will not be saved</p>,
            onOk() {
              handleConfirm();
            },
          });
        }}
      >
        Cancel
      </Button>
    </div>
  );
};
